import { createFileRoute } from '@tanstack/react-router'
import { ImpersonatePage } from 'features/auth'

export const Route = createFileRoute('/impersonate')({
  component: ImpersonatePage,
  beforeLoad(ctx) {
    ctx.context.auth.removeCredentials(false)
  },
})
